

namespace TabAurous.Retail {
    import fld = POSApprovalItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class POSApprovalDialog extends _Ext.TransDialog<POSApprovalRow, any> {

        protected getFormKey() { return POSApprovalForm.formKey; }
        protected getIdProperty() { return POSApprovalRow.idProperty; }
        protected getLocalTextPrefix() { return POSApprovalRow.localTextPrefix; }
        protected getNameProperty() { return POSApprovalRow.nameProperty; }
        protected getService() { return POSApprovalService.baseUrl; }
        protected getDeletePermission() { return POSApprovalRow.deletePermission; }
        protected getInsertPermission() { return POSApprovalRow.insertPermission; }
        protected getUpdatePermission() { return POSApprovalRow.updatePermission; }
        protected useViewMode() { return true; }
        protected useEditMode() { return true; }

        public form = new POSApprovalForm(this.idPrefix); 

        TaxArray: any[];
        TaxRegistred: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public CurrencyId: number;
        public useMF: boolean;

        constructor() {
            super();

            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            q.initItemEditor(this, this.form.ReceiptDetails, Config);
            //q.hideCaption(this.form.Posted);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ReceiptDetails);
            q.SetSix12Column(this.form.ReceiptDetails);
            q.setTextRightAlign(this.form.MF);

            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.hideEditorCategoryLabel(this.form.ReceiptDetails.element);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            q.hideCaption(this.form.CustomerName);
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            this.CurrencyId = Q.Authorization.userDefinition.CurrencyId;

            // **** Get Party Details using PartyID **** 
            this.form.POSCustomerId.changeSelect2(e => {
                var cid = this.form.POSCustomerId.value;
                if (cid != "") {
                    let CustomerDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: cid }, response => { CustomerDetails = response.Entity }, { async: false });
                    var fname = CustomerDetails.FirstName == null ? "" : CustomerDetails.FirstName;
                    var lname = CustomerDetails.LastName == null ? "" : CustomerDetails.LastName;
                    this.form.CustomerName.value = fname + lname;
                    this.form.POSCustomerId.value = CustomerDetails.POSCustomerId.toString();
                    this.form.Address.value = CustomerDetails.Address;
                    this.form.BirthDate.value = CustomerDetails.BirthDate;
                    this.form.Anniversary.value = CustomerDetails.Anniversary;
                    this.form.Mobile.value = parseFloat(CustomerDetails.Mobile);
                    this.form.PanNumber.value = CustomerDetails.PanNumber;
                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
                this.ExchangeRate = ExchangeDetails.ExchRate;
                this.SetAmountFields(parseInt(this.form.CurrencyId.value))
            });

            this.form.ExchRate.changeSelect2(e => {
                this.ExchangeRate = this.form.ExchRate.value;
            });

            //Load Image after Row in Details is Clicked
            var self = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {
                var x: Serenity.UploadedFile = {
                    Filename: self.Image,
                    OriginalName: ""
                }
                self.form.ProductItemImage.value = x;
                q.setImageEditorHeight(self.form.ProductItemImage, 160);
            });

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);
                if (Items.length > 0)
                    q.showAndDisableField(this.form.MF);
                else {
                    if (this.useMF)
                        q.showAndSetRequiredField(this.form.MF);
                }
            });
            (this.form.ReceiptDetails.view as any).onRowCountChanged.subscribe(() => {

                this.CalculateTotals();
            });
            this.form.MF.changeSelect2(e => {
                var mf = this.form.MF.value;
                if (mf < 50) {
                    Q.notifyWarning('MF cannot be less than 50');
                    this.form.MF.value = 50;
                    return;
                }
            });
            this.validateForm();
        }


        public CalculateAmountandTax(Items: any, TotalItems: number) {

            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var ItemTotal: 0;
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;

                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < codearray.length; i++) {
                    if (codearray[i] == x.HSN) {
                        amtarray[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    codearray.push(x.HSN);
                    amtarray.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (ItemTotal == TotalItems && TaxApplicable) {


                this.form.GrossAmount.value = gramt + TaxAmount;

                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt;

                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;

            }

            this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
            this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;


        }

        public CalculateTotals() {

            var Receipts: any;
            Receipts = this.form.ReceiptDetails.getItems();
            var ItemTotal = 0;
            var TotalItems = this.form.ReceiptDetails.getItems().length;
            if (ItemTotal > 0) {
                ItemTotal = 0;
            }

            if (Receipts.length == TotalItems) {
                var totalamount = 0;
                for (var i = 0; i < Receipts.length; i++) {
                    totalamount += parseFloat(Receipts[i].Amount);

                }
                this.form.ReceiptAmount.value = totalamount;
            }
        }
        protected onDialogOpen() {
            super.onDialogOpen();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0 && this.isNew) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }
            var useMF = q.ToBool(GetConfigValue(1022));  
            this.useMF = useMF;
            if (useMF) {
                q.showAndSetRequiredField(this.form.MF);
            } else {
                q.hideField(this.form.MF);
            }
        }


        SetAmountFields(value: number) {
            if (value != this.CurrencyId) {
                var CC = OMS.CurrencyMasterRow.getLookup().itemById[Q.Authorization.userDefinition.CurrencyId].CurrencyName;
                var FC = OMS.CurrencyMasterRow.getLookup().itemById[this.form.CurrencyId.value].CurrencyName;

                q.showAndDisableField(this.form.CCGrossAmount);
                q.showAndDisableField(this.form.CCNetAmount);
                q.setEditorLabel(this.form.GrossAmount, 'Total (' + FC + ')');
                q.setEditorLabel(this.form.NetAmount, 'Amount (' + FC + ')');
                q.setEditorLabel(this.form.CCGrossAmount, 'Total (' + CC + ')');
                q.setEditorLabel(this.form.CCNetAmount, 'Amount (' + CC + ')');

                var columns = this.form.ItemDetails.slickGrid.getColumns();

                Q.first(columns, x => x.field === fld.CCGrossAmount).name = Q.first(columns, x => x.field === fld.CCGrossAmount).name + ' (' + CC + ')';
                //Q.first(columns, x => x.field === fld.CCNetAmount).name = 
                //Q.first(columns, x => x.field === fld.GrossAmount).name = 
                //Q.first(columns, x => x.field === fld.NetAmount).name = 

            }
            else {

                q.hideField(this.form.CCGrossAmount);
                q.hideField(this.form.CCNetAmount);
                q.setEditorLabel(this.form.GrossAmount, 'Total');
                q.setEditorLabel(this.form.NetAmount, 'Amount');

            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            //Delete Click Override
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            //Edit Click Override
            //var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            //var oldEditClick = btnEdit.onClick;
            //btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            /*
                        btns.push(TabAurous.Common.ReportHelper.createToolButton({
                            title: 'Print',
                            cssClass: 'export-pdf-button',
                            icon: 'fa fa-print text-blue',
                            reportKey: 'Retail.POSApprovalVoucher',
                            getParams: () => ({
                                TransID: this.get_entityId()
                            })
                        }));*/

            var postingpermission = Q.Authorization.hasPermission('Retail:POSApproval:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                    POSApprovalService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            btns.push(TabAurous.Common.ReportHelper.createReportButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Reports.PurchaseMaster',
                getDocumentId:()=> this.form.VoucherTypeId.value,
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                POSApprovalService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        validateBeforeSave() {
            let Isvalid = super.validateBeforeSave();
            Isvalid = ValidateTransaction(this.form.ItemDetails.getItems(), this.form.Pieces.value, this.form.Weight.value);
            return Isvalid;
        }
     }
}